import { create } from 'zustand'
import { IAuthStore, IIntrospect } from '@/types/UserTypes'
import { IPaginatedEvents } from '@/types/EventTypes'

const useAuthStore = create<IAuthStore>((set) => ({
  isLoggedIn: false,
  setIsLoggedIn: (isLoggedIn: boolean) => set({ isLoggedIn }),
  isTokenChecked: false,
  setIsTokenChecked: (isTokenChecked: boolean) => set({ isTokenChecked }),
  errMsg: "",
  setErrMsg: (errMsg: string) => set({ errMsg }),
  userDetails: {
    email: "",
    user_id: 0,
    exp: 0,
    firstName: "",
    lastName: "",
    iat: 0,
    user_level: 0,
    verification: {
      id: 0,
      verification_files: [],
      status: "pending",
      allowed_product_types: [],
    },
    is_supplier: false,
  },
  setUserDetails: (userDetails: IIntrospect) => set({ userDetails }),
  userEvents: [],
  setUserEvents: (events: any[]) => set({ userEvents: events }),
  hasEvents: true,
  setHasEvents: (hasEvents: boolean) => set({ hasEvents }),
}))

export { useAuthStore }
